import * as React from "react";

const IconCheckmark: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="9" height="7" viewBox="0 0 9 7" fill="currentColor"><polygon fill="currentColor" points="11 4.137 10.658 4.456 5.566 9.183 5.226 9.5 4.887 9.183 2.342 6.82 2 6.503 2.681 5.866 3.023 6.182 5.226 8.229 9.977 3.817 10.319 3.5 11 4.137" transform="translate(-2 -3)"/></svg>;
};

export default React.memo(IconCheckmark);
